import { DocumentStatusHeader, OnboardingDocumentStatus, SignDocumentsStatus } from '@helpers/OnboardingSteps';
import {
  AccessTimeFilled,
  Cancel,
  CheckCircle,
  Error as ErrorIcon,
  HistoryToggleOff,
  RemoveRedEye,
  Warning,
} from '@mui/icons-material';

import { DocumentStatusProps } from './DocumentStatuses';

export const dictDocumentStatuses: DocumentStatusProps[] = [
  {
    Icon: Warning,
    text: 'status_mandatory',
    color: '#FFC133',
  },
  {
    Icon: ErrorIcon,
    text: 'status_missing',
    color: '#33CDFF',
  },
  {
    Icon: HistoryToggleOff,
    text: 'status_review',
    color: '#5c6573',
  },
  {
    Icon: Cancel,
    text: 'status_rejected',
    color: '#E87A71',
  },
  {
    Icon: CheckCircle,
    text: 'status_verified',
    color: '#73D85A',
  },
  {
    Icon: HistoryToggleOff,
    text: 'validate',
    color: '#5c6573',
  },
];

export const getDocumentStatusIconAndHeader = (isMandatory: boolean, status: string) => {
  if (isMandatory && status === OnboardingDocumentStatus.MISSING) {
    return { icon: <Warning fontSize="small" htmlColor="#FFC133" />, header: DocumentStatusHeader.MANDATORY };
  }
  switch (status) {
    case OnboardingDocumentStatus.VALIDATING:
      return { icon: <HistoryToggleOff fontSize="small" htmlColor="#5c6573" />, header: DocumentStatusHeader.REVIEW };
    case OnboardingDocumentStatus.MISSING:
      return { icon: <ErrorIcon fontSize="small" htmlColor="#33CDFF" />, header: DocumentStatusHeader.MISSING };
    case OnboardingDocumentStatus.REVIEW:
      return { icon: <HistoryToggleOff fontSize="small" htmlColor="#5c6573" />, header: DocumentStatusHeader.REVIEW };
    case 'PREVIEW':
      return { icon: <CheckCircle fontSize="small" htmlColor="#ADADB5" />, header: DocumentStatusHeader.VERIFIED };
    case OnboardingDocumentStatus.REJECTED:
      return { icon: <Cancel fontSize="small" htmlColor="#E87A71" />, header: DocumentStatusHeader.REJECTED };
    case OnboardingDocumentStatus.VERIFIED:
      return { icon: <CheckCircle fontSize="small" htmlColor="#73D85A" />, header: DocumentStatusHeader.VERIFIED };
    case 'SIGNED':
      return { icon: <CheckCircle fontSize="small" htmlColor="#73D85A" />, header: DocumentStatusHeader.SIGNED };
    default:
      return { icon: <Warning fontSize="small" htmlColor="#FFC133" />, header: DocumentStatusHeader.UNKNOWN };
  }
};

export const getDocumentForSignatureStatusIcon = (status: string) => {
  switch (status) {
    case SignDocumentsStatus.DOCUMENT_NOT_AVAILABLE:
      return <ErrorIcon style={{ fontSize: 16 }} htmlColor="#968c83" />;
    case OnboardingDocumentStatus.MISSING:
    case SignDocumentsStatus.NOT_SEEN:
    case SignDocumentsStatus.NOT_ACKNOWLEDGED:
    case SignDocumentsStatus.SIGNATURE_MISSING:
      return <ErrorIcon style={{ fontSize: 16 }} htmlColor="#FFC133" />;
    case OnboardingDocumentStatus.REVIEW:
      return <AccessTimeFilled style={{ fontSize: 16 }} htmlColor="#33CDFF" />;
    case SignDocumentsStatus.PREVIEW:
    case SignDocumentsStatus.SEEN:
      return <RemoveRedEye style={{ fontSize: 16 }} htmlColor="#33CDFF" />;
    case OnboardingDocumentStatus.VERIFIED:
    case SignDocumentsStatus.SIGNED:
    case SignDocumentsStatus.ACKNOWLEDGED:
      return <CheckCircle style={{ fontSize: 16 }} htmlColor="#73D85A" />;
    default:
      return <ErrorIcon style={{ fontSize: 16 }} htmlColor="#FFC133" />;
  }
};
